import React, { useState } from 'react'

// Node Modules
import { useTranslation } from 'react-i18next'

// Components
import { ExpandSectionIcon, CollapseSectionIcon } from 'components/SASIcon'

// Styles
import styles from './Collapsible.module.scss'

interface Props {
  title: React.ReactNode,
  content: React.ReactNode,
  sectionLabel: string
}

const Collapsible = ({ title, content, sectionLabel }:Props) => {
  const [collapsed, setCollapsed] = useState(false)
  const { t } = useTranslation()

  const buttonTitle = collapsed ?
    t('helpcenter-gui-icu.content.collapse.show_button.label', {sectionLabel}) :
    t('helpcenter-gui-icu.content.collapse.hide_button.label', {sectionLabel})
  function handleClick() {
    setCollapsed(!collapsed)
  }

  const collapseButton = <a aria-label={buttonTitle} role="button" href="javascript:void(0)" className={`${styles.collapseTrigger} collapseTrigger`} onClick={handleClick} title={buttonTitle}><ExpandSectionIcon /><CollapseSectionIcon /></a>/* eslint-disable-line */

  return (
    <div className={`collapsible ${collapsed ? 'hidden' : ''}`}>
      {collapseButton}
      <div className={styles.collapseBlock}>
        { title }
        <div  className={styles.collapseWrapper}>{ content }</div>
      </div>  
    </div>
  )
}

export default Collapsible